import {
    ADD_BANNER_FAIL,
    ADD_BANNER_SUCCESS,
    DELETE_BANNER_FAIL,
    DELETE_BANNER_SUCCESS,
    EXPORT_BANNER_FAIL,
    EXPORT_BANNER_SUCCESS,
    GET_BANNER_DETAILS_FAIL,
    GET_BANNER_DETAILS_SUCCESS,
    GET_BANNER_LISTING_FAIL,
    GET_BANNER_LISTING_SUCCESS,
    RESET_BANNER_ATTACHMENT_STATE,
    RESET_BANNER_STATE,
    UPDATE_BANNER_FAIL,
    UPDATE_BANNER_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    bannerListing: [],
    bannerDetails: [],
    addBanner: [],
    updateBanner: [],
    deleteBanner: [],
    exportBanner: [],
    error: [],
}

const Banner = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_BANNER_LISTING_SUCCESS:
            return {
                ...state,
                bannerListing: action.payload
            }
        case GET_BANNER_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_BANNER_DETAILS_SUCCESS:
            return {
                ...state,
                bannerDetails: action.payload
            }
        case GET_BANNER_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_BANNER_SUCCESS:
            return {
                ...state,
                addBanner: action.payload
            }
        case ADD_BANNER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_BANNER_SUCCESS:
            return {
                ...state,
                updateBanner: action.payload
            }
        case UPDATE_BANNER_FAIL:
            return {
                ...state,
                error: action.payload,
                updateBanner: action.payload,
            }

        case DELETE_BANNER_SUCCESS:
            return {
                ...state,
                deleteBanner: action.payload
            }
        case DELETE_BANNER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_BANNER_SUCCESS:
            return {
                ...state,
                exportBanner: action.payload
            }
        case EXPORT_BANNER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_BANNER_ATTACHMENT_STATE:
            return {
                ...state,
                exportBanner: [],
                error: [],
            }
        case RESET_BANNER_STATE:
            return {
                ...state,
                bannerListing: [],
                bannerDetails: [],
                addBanner: [],
                updateBanner: [],
                deleteBanner: [],
                exportBanner: [],
                error: [],
            }
        default:
            return state
    }
}

export default Banner
